import { createContext, Context } from 'react';
import { User } from 'firebase/auth';

export type AuthContextType = LoggedInAuthContextType | LoggedOutAuthContextType;

type LoggedInAuthContextType = {
  isLoggedIn: boolean;
  user: User;
};

type LoggedOutAuthContextType = {
  isLoggedIn: false;
  user: null;
};

export const AuthenticationContext: Context<AuthContextType> =
  createContext<AuthContextType>({
    isLoggedIn: false,
    user: null,
  });
